<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="inner-wrap">

  <ul class="join-tab">
    <li><span>01.</span>약관동의 및 본인인증</li>
    <li><span>02.</span>정보입력</li>
    <li class="active"><span>03.</span>가입완료</li>
  </ul>

  <div class="join-step3">
    <div class="img"></div>
    <div class="msg">한국냉동공조산업협회 홈페이지<br/><span>회원 가입 완료</span></div>
	  <div class="btn-area">
      <!--
      <a routerLink="/member/login" class="btn1 login-btn">로그인</a>
      //-->
	    <a routerLink="/" class="btn1 main-btn">메인</a>
	  </div>
  </div>

</div>

<app-footer></app-footer>